// datePicker
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { isEmpty } from "lodash";
import logo from "../assets/images/logo/main-logo-removebg.png";
import { URL } from "../services/useAxios.tsx";
import { Helmet } from "react-helmet";

const charMap = [
  {
    pattern: /\u0660|\u06F0/g,
    replace: "0",
  },
  {
    pattern: /\u0661|\u06F1/g,
    replace: "1",
  },
  {
    pattern: /\u0662|\u06F2/g,
    replace: "2",
  },
  {
    pattern: /\u0663|\u06F3/g,
    replace: "3",
  },
  {
    pattern: /\u0664|\u06F4/g,
    replace: "4",
  },
  {
    pattern: /\u0665|\u06F5/g,
    replace: "5",
  },
  {
    pattern: /\u0666|\u06F6/g,
    replace: "6",
  },
  {
    pattern: /\u0667|\u06F7/g,
    replace: "7",
  },
  {
    pattern: /\u0668|\u06F8/g,
    replace: "8",
  },
  {
    pattern: /\u0669|\u06F9/g,
    replace: "9",
  },
];

function characterPersionToEnglish(text) {
  let temp = text;
  charMap.forEach((value) => {
    temp = temp.replaceAll(value.pattern, value.replace);
  });
  return temp;
}

/*
 * @param {string} timestamp time in seconds
 *@param {string} format the format of time
 *@return {string} the time based on format.
 */
const TimeStampToJalali = (timestamp, format) => {
  let date = new DateObject({
    date: timestamp,
    // calendar: persian,
    // locale: persian_fa,
    // format: format,
  }).convert(persian, persian_fa);
  return date.format(format);
};

const showErrorInput = (err, name, center = false, isSelect = false) => {
  return (
    err[name] && (
      <p
        className={`text-danger font-12-500 mr-y-6 ${
          center ? "text-center" : "mr-r-10"
        }`}
      >
        {err[name].message}
      </p>
    )
  );
};

const pathMaker = (path) => {
  if (path && !isEmpty(path)) {
    return `${URL}${path}`;
  } else {
    return logo;
  }
};

const getPercentDiscount = (price, discount) => {
  return Math.ceil(discount / (price / 100));
};

// const translateToProductReactSelect = (arrayValue, reverse) => {
//   let after = [];
//   if (reverse) {
//     // react select to api
//     for (let index = 0; index < arrayValue.length; index++) {
//       let obj = {};
//       obj.title = arrayValue[index].label;
//       obj.id = arrayValue[index].value;
//       after.push(obj);
//     }
//   } else {
//     // api to react select
//     for (let index = 0; index < arrayValue.length; index++) {
//       let obj = {};
//       obj.label = arrayValue[index].title;
//       obj.value = arrayValue[index].products__id;
//       obj.option = JSON.parse(arrayValue[index].available_order_option_ids);
//       obj.default_price = arrayValue[index].default_price;
//       obj.image = arrayValue[index].path;
//       obj.total_inventory_count = arrayValue[index].total_inventory_count;
//       obj.default_weight_from = arrayValue[index].default_weight_from;
//       obj.default_weight_to = arrayValue[index].default_weight_to;
//       obj.main_cover_file_id = arrayValue[index].main_cover_file_id;
//
//       after.push(obj);
//     }
//   }
//
//   return after;
// };
// const useAnalyticsEventTracker = (
//   category = "Blog category",
//   actionParam,
//   labelParam
// ) => {
//   const eventTracker = (action = actionParam, label = labelParam) => {
//     ReactGA.event({ category, action, label });
//   };
//   return eventTracker;
// };

const translateToReactSelect = (
  reverse,
  arrayValue,
  labelName,
  needArray = false,
  valueName = "id"
) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue?.length; index++) {
      let obj = {};
      if (arrayValue[index][valueName]) {
        obj[valueName] = arrayValue[index][valueName];
      } else {
        obj[labelName] = arrayValue[index].label;
        obj[valueName] = arrayValue[index].value;
      }

      after.push(obj[valueName]);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue?.length; index++) {
      let obj = {};
      if (needArray) {
        const {
          id,
          [labelName]: removedProperty,
          ...remain
        } = arrayValue[index];
        obj = { ...obj, ...remain };
      }
      obj.label = arrayValue[index][labelName];
      obj.value = arrayValue[index][valueName];

      after.push(obj);
    }
  }
  return after;
};

function mobileChecker(mobile) {
  const mobileRgx = /^(\+98|0)( |-){0,1}9\d{2}( |-){0,1}\d{3}( |-){0,1}\d{4}$/;
  return mobileRgx.test(mobile);
}
/**
 *
 * @param {*} title
 * @param {*} description
 * @param {*} img
 * @param {*} type
 * @returns
 */
function helmetFunction(title, description, img = logo, type = "") {
  return (
    <Helmet>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="og:locale" content="fa_IR" />
      <meta name="og:type" content={type} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:site_name" content="یانگ گالری" />
      <meta name="og:image" content={img} />
      <meta name="og:image:width" content={"100px"} />
      <meta name="og:image:height" content={"auto"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:site" content="یانگ گالری" />
      {img != null && <meta name="twitter:image" content={img} />}
      <meta name="description" content={description} />
    </Helmet>
  );
}
const SOCIAL_MEDIA = {
  INSTA: "https://instagram.com/young_gallerryy",
  TELEGRAM: "https://t.me/young_gallerry",
  // TELEGRAM: "https://t.me/Young_adminn",
  // EMAIL: "mailto:Nasr.electric.store@gmail.com",
  WHATSAPP: "https://wa.me/09378592420?text=",
};
/**
 * 0 => instagram
 * 1 => telegram
 * 2 => in shop
 * 3 => whatsapp
 * 20 => online
 */
// const COMMUNICATION_TYPE = ["اینستاگرام", "تلگرام", "حضوری", "واتسآپ"];
const COMMUNICATION_TYPE = ["سوشال مدیا", "حضوری"];
let frontURL = "https://young-gallery.com";
// let frontURL = "https://young-gallery.tatdemo.ir";
const SHARE_LINKS = {
  telegram: `https://t.me/share/url?url=${frontURL}`,
  whatsapp: `https://api.whatsapp.com/send/?text=${frontURL}`,
  eitaa: `https://www.eitaa.com/share/url?url=${frontURL}`,
  bale: `https://ble.ir/share/url?url=${frontURL}`,
  gmail: `mailto:?subject="از لینک زیر دیدن فرمایید";body=${frontURL}`,
  frontURL: frontURL,
};

const routes_title = [
  { route: "/admin-panel/customer-club", title: "باشگاه مشتریان" },
  // { route: "/", title: "خانه" },
  { route: "/blog", title: "بلاگ" },
  { route: "/products", title: "لیست محصولات" },
  { route: "/product", title: "محصول" },
  { route: "/admin-panel/orders", title: "سفارشات ادمین" },
  { route: "/admin-panel/user-management", title: "مدیریت کاربران" },
  { route: "/admin-panel/category-management", title: "مدیریت دسته بندی" },
  { route: "/admin-panel/option-management", title: "مدیریت آپشنها" },
  { route: "/admin-panel/customer-club", title: "باشگاه مشتریان" },
  { route: "/admin-panel/setting", title: "تنظیمات سایت" },
  { route: "/admin-panel/factors", title: "فاکتور ادمین" },
  { route: "/admin-panel/reports", title: "گزارشات ادمین" },
  { route: "/admin-panel/finance", title: "امورمالی ادمین" },
  { route: "/admin-panel/bank-info", title: "اطلاعات بانکی ادمین" },
  { route: "/customer-panel/profile", title: "پروفایل کاربر" },
  { route: "/customer-panel/orders", title: "سفارشات کاربر" },
  { route: "/admin-panel/validation-product-factor", title: "مغایرت انبار" },
  { route: "/admin-panel/report-product-factor", title: "گزارش انبار" },
  { route: "/customer-panel/profile", title: "پروفایل کاربر" },
  { route: "/customer-panel/profile", title: "پروفایل کاربر" },
  { route: "/customer-panel/profile", title: "پروفایل کاربر" },
  { route: "/about-us", title: "درباره ما" },
  { route: "/contact-us", title: "تماس با ما" },
  { route: "/admin-panel/visits", title: "گزارش مخاطب" },
];
export {
  TimeStampToJalali,
  pathMaker,
  showErrorInput,
  characterPersionToEnglish,
  // translateToProductReactSelect,
  getPercentDiscount,
  // useAnalyticsEventTracker,
  translateToReactSelect,
  mobileChecker,
  helmetFunction,
  SOCIAL_MEDIA,
  frontURL,
  COMMUNICATION_TYPE,
  SHARE_LINKS,
  routes_title,
};
